import { ComposerTimeFormat, ComposerTimeFormatType } from "../time/ComposerTimeFormat";

export class ComposerSettings
{
  partResolutionBeats:number = 8;
  timeFormat:ComposerTimeFormatType = ComposerTimeFormatType.BARS_AND_BEATS;
}